var nb = require('../../nb');
module.exports = nb.define({
    view:{
        'class':'login-menu',
        $html:{
            'class':'menu-content',
            $html:[{
                tag:'h3',
                $text:'拥有A.R.T.西区账户您将获得以下权利'
            },{
                tag:'ul',
                $html:[{
                    tag:'li',
                    $text:'保留您的心愿清单'
                },{
                    tag:'li',
                    $text:'个性化您的推荐内容'
                },{
                    tag:'li',
                    $text:'订单寄送追踪及退换货管理'
                }]
            },{
                'class':'btn-menu',
                $html:[{
                    $name:'login',
                    'class':'btn-user btn-login btn-solid-blue',//btn-user btn-login
                    tag:'a',
                    href:nb.bind('loginHref'),
                    $text:'登录'
                },{
                    $name:"register",
                    'class':'btn-user btn-register btn-line-black',//btn-user btn-register
                    tag:'a',
                    href:'register.html',
                    $text:'注册'
                }]
            }]
        }
    },

    method:{
        init:function () {
            var self = this;
            // this.$('login').on('click',function () {
            //     var model = self.getModel();
            //     debugger
            //     model.set('click','login',{skipSameValue:false});
            // });
            // this.$('register').on('click',function () {
            //     var model = self.getModel();
            //     model.set('click','register',{skipSameValue:false});
            // });
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/view/header/LoginMenu.js
// module id = 27
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32